import React from 'react';
import styled from 'styled-components';

import { Book } from '~/api/book/bookApiTypes';
import { BookCard } from '~/feature/book/BookCard/BookCard';
import { BookCardCover } from '~/feature/book/BookCard/BookCardCover';
import { lessThan } from '~/lib/mediaQuery';

export const CycleBookList = ({ books }: { books: Book[] }) => {
  return (
    <SCBookList>
      {books
        .map((book: Book) => {
          return (
            <BookCard
              key={book.id}
              book={book}
              cover={(
                <BookCardCover
                  coverImages={book?.coverImages}
                  book={{
                    title: book?.name,
                    author: book?.authors?.[0]?.name,
                  }}
                  itemProp="thumbnail"
                  media={{
                    S: `
                (max-width: 436px),
                (min-width: 768px) and (max-width: 839px),
                (min-width: 1025px) and (max-width: 1059px),
              `,
                    M: `
                (min-width: 437px) and (max-width: 624px),
                (min-width: 840px) and (max-width: 989px),
                (min-width: 1060px) and (max-width: 1199px),
                (min-width: 1200px)`,
                    L: `
                (min-width: 625px) and (max-width: 767px),
                (min-width: 990px) and (max-width: 1023px)
              `,
                  }}
                />
              )}
            />
          );
        })}
    </SCBookList>
  );
};

const SCBookList = styled.div`
  --column-gap: 24px;
  --row-gap: 28px;
  --items-count: 4;
  --column-gap-count: calc(var(--items-count) - 1);
  --column-gaps-width: calc(var(--column-gap) * var(--column-gap-count));
  --free-space-for-items: calc(100% - calc(var(--column-gaps-width)));
  --item-width: calc(var(--free-space-for-items) / var(--items-count));

  display: grid;
  justify-content: flex-start;
  grid-template-columns: repeat(var(--items-count), var(--item-width));
  grid-gap: var(--row-gap) var(--column-gap);
  padding: 2px;
  width: 100%;
  height: 100%;

  ${lessThan('md')} {
    --items-count: 3;
    --column-gap: 14px;
    --row-gap: 18px;
  }

  ${lessThan('sm')} {
    --items-count: 3;
    --column-gap: 10px;
    --row-gap: 12px;
  }
`;
